export interface HeroSlide {
  id: string;
  tag: string;
  title: string;
  summary: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "news-1",
    tag: "最新专辑",
    title: "森泽佳奈全新专辑《潮汐》正式发行",
    summary:
      "历时两年打磨，第三张个人专辑以海洋与光影为线索，收录十首全新作品，上线首周即登顶数字音乐榜。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20editorial%20image%20of%20a%20vast%20calm%20ocean%20under%20a%20deep%20navy%20dusk%20sky%20with%20a%20warm%20amber%20glowing%20horizon%20line%2C%20soft%20mist%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20artistic%20atmospheric%20mood&width=1600&height=900&seq=hero-01&orientation=landscape",
  },
  {
    id: "news-2",
    tag: "影视新作",
    title: "主演电影《静默之城》正式定档",
    summary:
      "在喧嚣都市中寻找真相的调查记者，一场关于记忆与真相的静默探寻，即将与观众见面。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20editorial%20image%20of%20a%20misty%20modern%20city%20skyline%20at%20blue%20hour%20with%20deep%20navy%20tones%20and%20warm%20amber%20window%20lights%2C%20fog%20layers%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20moody%20mysterious%20mood&width=1600&height=900&seq=hero-02&orientation=landscape",
  },
  {
    id: "news-4",
    tag: "巡演官宣",
    title: "个人巡演《森泽佳奈 · 光影之旅》启动",
    summary:
      "以专辑《潮汐》为主线的现场演出，首轮将在五座城市举行，带来沉浸式的光影观演体验。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20editorial%20image%20of%20a%20concert%20stage%20with%20dramatic%20deep%20navy%20beam%20lights%20and%20warm%20amber%20glow%20in%20haze%2C%20empty%20stage%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20immersive%20atmospheric%20mood&width=1600&height=900&seq=hero-03&orientation=landscape",
  },
];